import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {Order} from '../../models/order';
import {select, Store} from '@ngrx/store';
import * as fromOrders from '../../reducers';
import {CancelOrdersAction} from '../../actions/cancel-order';
import {skipWhile} from 'rxjs/operators';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-cancel-order',
  templateUrl: './cancel-order.component.html',
  styleUrls: ['./cancel-order.component.scss']
})
export class CancelOrderComponent implements OnInit {

  @ViewChild('staticModal', {static: false}) public staticModal: ModalDirective;
  order$: Observable<Order>;
  uuid: string;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private store: Store<fromOrders.AppState>) {
  }

  ngOnInit(): void {
    this.order$ = this.store.pipe(select(fromOrders.selectors.getOrder));
    this.order$.pipe(
      skipWhile(data => !!data)
    ).subscribe((order: Order) => {
      if (order) {
        this.uuid = order.uuid
      }
    })
  }

  send(): void {
    this.store.dispatch(new CancelOrdersAction({'orderUuids': [this.uuid]}));
    this.close();
  }
  close(): void {
    this.staticModal.hide();
  }

  open(): void {
    this.staticModal.show();
  }

}
